/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {creditFirstTimeBorrow} from '../api'

export const useMutationCreditFirstTimeBorrow = createReactQueryMutationHook('creditFirstTimeBorrow', creditFirstTimeBorrow)
